import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { useCanvasStore } from '@/modules/canvas/store';

import { IOriginService } from './IOriginService';
import { OriginServiceImpl } from './OriginServiceImpl';

export class OriginServiceFactory {
  private static instance: OriginServiceFactory | null = null;
  private floorplanDesignStore: typeof useFloorplanDesignStore;
  private canvasStore: typeof useCanvasStore;

  public static initialize(
    floorplanDesignStore: typeof useFloorplanDesignStore,
    canvasStore: typeof useCanvasStore,
  ) {
    OriginServiceFactory.instance = new OriginServiceFactory(
      floorplanDesignStore,
      canvasStore,
    );
  }

  public static getInstance() {
    if (OriginServiceFactory.instance === null) {
      throw new Error(
        'OriginServiceFactory not yet initialized. Call OriginServiceFactory.initialize() first.',
      );
    }
    return OriginServiceFactory.instance;
  }

  private constructor(
    floorplanDesignStore: typeof useFloorplanDesignStore,
    canvasStore: typeof useCanvasStore,
  ) {
    this.floorplanDesignStore = floorplanDesignStore;
    this.canvasStore = canvasStore;
  }

  public createService(): IOriginService {
    const result: IOriginService = this.makeService();

    return result;
  }

  private makeService(): IOriginService {
    return new OriginServiceImpl(
      this.floorplanDesignStore,
      this.canvasStore,
    );
  }
}
